/*
 * fn: removeCookie
 *
 * Removes a cookie
 *
 */
import { type CookieSetOptions } from 'universal-cookie'

import { getCookies } from './getCookies'

export const removeCookie = (key: string, options?: CookieSetOptions) => {
  getCookies().remove(key, { path: '/', ...options })
}
